import * as React from 'react'

import arrowIcon from 'shared/assets/icons/arrow-top-right.svg'
import downloadIcon from 'shared/assets/icons/download.svg'
import { Text, TextName } from 'sdk'
import { Pill } from 'sdk/pill/Pill'
import { OutlineGlassBackgroundCard } from 'components/outline-glass-background-card/OutlineGlassBackgroundCard'

import { useWindowSize } from 'core/hooks/useWindowSize'
import type { ResourcesDocumentationCmsContent } from 'core/services/cms/interfaces'

import classes from './DocumentationSection.module.scss'

interface DocumentationSectionProps {
  content: ResourcesDocumentationCmsContent
}

export const DocumentationSection: React.FC<DocumentationSectionProps> = ({ content }) => {
  const { width } = useWindowSize()
  const isAboveLg = width > 1024
  const isAboveSm = width > 640
  const bgImage = isAboveLg ? content.desktopBackgroundUrl : content.mobileBackgroundUrl

  const renderDocumentationLinks = (): React.ReactElement => (
    <div className={classes.buttonsRow}>
      {content.links.map((link) => (
        <a key={link.label} href={link.url} target='_blank' rel='noopener noreferrer'>
          <Pill variant='outline'>
            <div className={classes.pillContent}>
              <Text type={TextName.Text}>{link.label}</Text>
              <img src={arrowIcon} alt='' className={classes.arrowIcon} />
            </div>
          </Pill>
        </a>
      ))}
    </div>
  )

  const renderDownloadButton = (): React.ReactElement => (
    <a
      href={content.downloadButtonUrl}
      target='_blank'
      rel='noopener noreferrer'
      className={classes.downloadLink}
    >
      <Pill variant='gradientFilled'>
        <div className={classes.downloadPillContent}>
          <img src={downloadIcon} alt='' className={classes.downloadIcon} />
          <Text type={TextName.Text}>{content.downloadButtonText}</Text>
        </div>
      </Pill>
    </a>
  )

  const renderCardContent = (): React.ReactElement => (
    <>
      <Text type={TextName.H3}>{content.body}</Text>
      {renderDocumentationLinks()}
      {renderDownloadButton()}
    </>
  )

  return (
    <section className={classes.wrapper}>
      <Text type={TextName.H2}>{content.title}</Text>
      {isAboveSm ? (
        <div className={classes.container} style={{ backgroundImage: `url(${bgImage})` }}>
          <OutlineGlassBackgroundCard className={classes.card}>{renderCardContent()}</OutlineGlassBackgroundCard>
        </div>
      ) : (
        <OutlineGlassBackgroundCard className={classes.card}>{renderCardContent()}</OutlineGlassBackgroundCard>
      )}
    </section>
  )
}
